import React from 'react';
import { UserTicketDto } from '../../../../types';

type Props = {
  isTransfer: boolean;
  isTicketOwner?: boolean;
  ticket: UserTicketDto;
};

const TicketHolder = ({ ticket, isTransfer, isTicketOwner }: Props) => (
  <div className="flex-1 flex-row flex">
    <img
      className="w-11 h-11 rounded-full border-1 border-solid border-neutral-700"
      src={ticket.owner.photoUrl || '/img/user/default.png'}
    />
    <div className="ml-2">
      <div className="font-bold text-base">
        {ticket.holder.firstName} {ticket.holder.lastName}
        {!isTransfer && <>&nbsp;(You)</>}
      </div>
      <div className="font-normal">
        {ticket.tier.name || ticket.tier.description}
        {!isTicketOwner && <>&nbsp;(Purchased by {ticket.owner.firstName})</>}
      </div>
    </div>
  </div>
);

export default TicketHolder;
